<template>
  <v-card class="pa-4 mb-4" v-if="!filters.user_id">
    <v-card-title>TOP 100 utenti per prenotazioni</v-card-title>
    <v-card-text style="overflow-y: auto; max-height: 600px; padding: 0;">
      <v-layout wrap>
        <v-flex xs12 md12>
          <v-data-table
              :headers="headers"
              :items="tableData"
              hide-default-footer
              dense
              class="elevation-1"
              :items-per-page="100"
          >
            <template v-slot:item.user_name="{ item }">
              <template v-if="item.user_id">
                <a
                    :href="`/#/customers/details/${item.user_id}`"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                  {{item.user_name}}
                </a>
              </template>
              <template v-else>
                {{item.user_name}}
              </template>
            </template>
            <template v-slot:item.total="{ item }">
              <strong>{{ item.total }}</strong>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
  <v-card class="pa-4 mb-4" v-else>
    <v-card-title>Statistiche utente</v-card-title>
    <v-card-text style="overflow-y: auto; max-height: 600px; padding: 0;">
      <v-layout wrap>
        <v-flex xs12 md12>
          <v-simple-table v-if="userForReliability && stats">
            <template v-slot:default>
              <tbody>
              <tr>
                <td>Affidabilità</td>
                <td v-if="userForReliability">
                  <div class="termometro">
                    <v-progress-linear
                        :value="getReliabilityScore(userForReliability)"
                        height="10"
                        :color="getReliabilityColor(getReliabilityScore(userForReliability),userForReliability)"
                        rounded
                    />
                    <small>{{ getReliabilityScore(userForReliability) }}%</small>
                  </div>
                </td>
              </tr>
              <tr>
                <td>N° Prenotazioni Totali</td>
                <td class="font-weight-bold text-center">{{stats.bookings_count_totals}}</td>
              </tr>
              <tr>
                <td>Da giocare</td>
                <td class="font-weight-bold info white--text text-center">{{stats.bookings_count_booked}}</td>
              </tr>
              <tr>
                <td>Confermate</td>
                <td class="font-weight-bold success white--text text-center">{{stats.bookings_count_completed}}</td>
              </tr>
              <tr>
                <td>Da confermare</td>
                <td class="font-weight-bold warning white--text text-center">{{stats.bookings_count_to_be_confirmed}}</td>
              </tr>
              <tr>
                <td>Annullate</td>
                <td class="font-weight-bold error white--text text-center">{{stats.bookings_count_canceled}}</td>
              </tr>
              <tr>
                <td>Interrotte</td>
                <td class="font-weight-bold error white--text text-center">{{stats.bookings_count_interrupted}}</td>
              </tr>
              <tr>
                <td>Dettagli utente</td>
                <td class="font-weight-bold align-content-center" style="text-align: center">
                  <a
                      :href="`/#/customers/details/${userInfo._id}`"
                      target="_blank"
                      rel="noopener noreferrer"
                  >
                    <v-btn x-small elevation="2" color="primary" class="mr-auto">
                      {{ $t('view') }}
                    </v-btn>
                  </a>
                </td>
              </tr>

              </tbody>
            </template>
          </v-simple-table>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>

</template>

<script>

import {mapActions} from "vuex";
import {getReliabilityColor, getReliabilityScore} from "@/utils/reliability";

export default {
  name: 'TopUsers',
  components: { },
  props: {
    filters: Object
  },
  data() {
    return {
      rawData: [],
      headers: [
        { text: 'Utente', value: 'user_name' },
        { text: 'Tot.', value: 'total', align: 'right' }
      ],
      userInfo: null,
      stats: null,
      userForReliability: {}
    };
  },
  computed: {
    tableData() {
      return this.rawData.map(r => {
        const name = (r.user_id) ? r.name +' '+ r.surname : ''  || `Prenotazioni Manuali`;
        return { user_name: name, total: r.total, user_id: r.user_id };
      }).sort((a, b) => b.total - a.total);
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler(newFilters) {
        this.fetchData(newFilters);
      }
    }
  },
  methods: {
    getReliabilityColor,
    getReliabilityScore,
    ...mapActions({
      'detailsItem':'customers/details',
    }),
    async fetchData(filters) {
      if (filters.user_id) {
        let fetchItem = await this.detailsItem({id:filters.user_id})
        this.userInfo = Object.assign({},fetchItem.result.user)
        this.stats = Object.assign({},fetchItem.result.bookings)
        let count_blacklists = this.userInfo.blacklists && this.userInfo.blacklists.length > 0 ? this.userInfo.blacklists.filter(obj => obj.status === 'active').length : 0
        let count_promo_code =  fetchItem.result.count_promo_code ? fetchItem.result.count_promo_code : 0

        this.userForReliability = {
          _id: this.userInfo._id,
          name: this.userInfo.name,
          surname: this.userInfo.name,
          phone: this.userInfo.phone,
          email: this.userInfo.email,
          active: this.userInfo.active,
          image: this.userInfo.image,
          created_at: this.userInfo.created_at,
          updated_at: this.userInfo.updated_at,
          bookings_count_completed : this.stats.bookings_count_completed,
          bookings_count_canceled : this.stats.bookings_count_canceled,
          bookings_count_to_be_confirmed : this.stats.bookings_count_to_be_confirmed,
          bookings_count_booked : this.stats.bookings_count_booked,
          bookings_count_interrupted : this.stats.bookings_count_interrupted,
          count_blacklist : count_blacklists,
          count_promo_code : count_promo_code,
          phone_verified: this.userInfo.phone_verified,
          email_verified: this.userInfo.email_verified,
        }


      }else {
        this.rawData = await this.$store.dispatch('analytics/getReservationsByUser', filters);
      }

    },
    goToDetails(id){
      this.$router.push('/customers/details/'+id)
    },
  }
};
</script>